import { useState, useCallback } from "react";
const useClipboard = (): {
  isCopiedToClipboard: boolean;
  isReadFromClipboard: boolean;
  copyToClipboard: (text: string) => void;
  readFromClipboard: () => void;
  clipboardText: string;
} => {
  const [isCopiedToClipboard, setIsCopiedToClipboard] = useState(false);
  const [isReadFromClipboard, setIsReadFromClipboard] = useState(false);
  const [clipboardText, setClipboardText] = useState("");

  const copyToClipboard = useCallback((text: string) => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(text)
        .then(() => {
          setIsCopiedToClipboard(true);
          setTimeout(() => setIsCopiedToClipboard(false), 1500);
        })
        .catch(() => {
          setIsCopiedToClipboard(false);
        });
    } else {
      const textarea = document.createElement("textarea");
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
      setIsCopiedToClipboard(true);
      setTimeout(() => setIsCopiedToClipboard(false), 1500);
    }
  }, []);

  const readFromClipboard = useCallback(() => {
    if (navigator.clipboard) {
      navigator.clipboard
        .readText()
        .then(() => {
          setIsReadFromClipboard(true);
          // Do something with the text from the clipboard
          setTimeout(() => setIsReadFromClipboard(false), 1500);
        })
        .catch(() => {
          setIsReadFromClipboard(false);
        });
    } else if (
      document.queryCommandSupported &&
      document.queryCommandSupported("paste")
    ) {
      const textarea = document.createElement("textarea");
      document.body.appendChild(textarea);
      textarea.focus();
      document.execCommand("paste");
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-explicit-any
      const clipboardData = (window as any).clipboardData.getData("Text");
      document.body.removeChild(textarea);
      setIsReadFromClipboard(true);
      setClipboardText(clipboardData as string);
      setTimeout(() => setIsReadFromClipboard(false), 1500);
    } else {
      setIsReadFromClipboard(false);
    }
  }, []);

  return {
    isCopiedToClipboard,
    isReadFromClipboard,
    copyToClipboard,
    readFromClipboard,
    clipboardText,
  };
};

export default useClipboard;
